import api from '../../shared/api/client';
import { API_ROUTES } from '../../shared/api/routes';

export const notificationsApi = {
  list: (params) => api.get(API_ROUTES.notifications.base, { params }),
  getUnreadCount: () => api.get(API_ROUTES.notifications.unreadCount),
  markRead: (id) => api.patch(API_ROUTES.notifications.read(id)),
  markAllRead: () => api.post(API_ROUTES.notifications.markAllRead),
};
